<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle :pageTitle="pageTitle" />
    <CreatePrize />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreatePrize from "@/components/Pages/Admin/Prizes/view.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "CreatePrizePage",
  components: {
    PageTitle,
    CreatePrize,
  },
  setup() {
    const route = useRoute();
    
    const pageTitle = computed(() => {
      return route.params.id ? "Editar Trofeo" : "Crear Trofeo";
    });

    return {
      pageTitle,
    };
  },
});
</script>